import React from "react"

import { Color } from "../../../../../constants/V2/color"
import Typography from "../../../../elements/V2/Typography"

type PayflexTermProps = {
  term: string
}

export const PayflexTerm = ({ term }: PayflexTermProps) => {
  return (
    <div className="flex items-center gap-10 md:items-start">
      <img
        className="h-[22px] w-[22px] md:mt-[2px]"
        src="/icons/payflex-check.svg"
        alt="Checkmark"
      />
      <Typography
        weight="book"
        font="grotesk"
        text={term}
        size="body-sm"
        color={Color.PayflexNavy}
      />
    </div>
  )
}
